module.exports = __webpack_public_path__ + "static/media/attendees_green.4298d95f.svg";